import ZTable from './ZTable.vue'

export default ZTable
